import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19 17H1L10 2L19 17ZM10.0039 13C9.79286 13.0001 9.61448 13.072 9.46875 13.2148C9.32307 13.3577 9.25 13.535 9.25 13.7461C9.2501 13.9571 9.32203 14.1355 9.46484 14.2812C9.60772 14.4269 9.78496 14.5 9.99609 14.5C10.2071 14.4999 10.3855 14.428 10.5312 14.2852C10.6769 14.1423 10.75 13.965 10.75 13.7539C10.7499 13.5429 10.678 13.3645 10.5352 13.2188C10.3923 13.0731 10.215 13 10.0039 13ZM9.25 12H10.75V8H9.25V12Z" })
});
export default SvgWarning;
